module.exports = __webpack_public_path__ + "static/media/logo-dashboard-cropped.94a154f4.png";